import Header from "@/components/Header";
import InspectionResultsView from "@/components/InspectionResultsView";

const InspectionResults = () => (
  <div className="min-h-screen bg-slate-50">
    <Header title="Inspection Results & SPC" />
    <div className="max-w-7xl mx-auto p-3 lg:p-6">
      <div className="mb-4">
        <h1 className="font-extrabold text-slate-900 text-xl">Inspection Results & SPC</h1>
        <p className="text-xs text-slate-400">निरीक्षण परिणाम और प्रक्रिया नियंत्रण</p>
      </div>
      <InspectionResultsView />
    </div>
  </div>
);

export default InspectionResults;
